import React from 'react';
import styled from 'styled-components';
import { brandColors, greenLight, grey500, black } from 'styles/colors';
import { slideIn } from 'styles/animation';
import { NavLink } from 'react-router-dom';
import { Section } from '../Section';

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const EditNavLink = styled(NavLink)`
	text-transform: uppercase;
	color: ${brandColors.green};
	position: absolute;
	top: 25px;
	right: 32px;
	cursor: pointer;

	font-size: 13px;
	line-height: 13px;
	font-weight: 500;

	@media (hover: hover) {
		&:hover {
			color: ${greenLight};
		}
	}
`;

export const StyledSection = styled(Section)`
	position: relative;
`;

export const MetadataSummary = styled(({ children, ...props }) => (
	<table {...props}>
		<tbody>{children}</tbody>
	</table>
))``;

export const MetadataSummaryLine = styled.tr``;

export const SummaryLabel = styled.td`
	color: ${grey500};
	font-size: 16px;
	line-height: 24px;
	text-transform: uppercase;
	font-weight: normal;
	padding: 10px 65px 10px 10px;
`;

export const SummaryValue = styled.td`
	color: ${black};
	font-size: 16px;
	font-weight: 500;
	line-height: 24px;
`;
export const FormHeader = styled.div`
	max-width: 896px;
	width: 100%;
	margin-top: 32px;

	animation-name: ${slideIn};
	animation-duration: 600ms;
	animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
	animation-delay: ${({ animationIndex }) => `${50 + animationIndex * 75}ms`};
	animation-fill-mode: both;
`;
export const FormTitle = styled.div`
	color: ${black};
	font-size: 33px;
	font-weight: 500;
	line-height: 41px;
	margin-bottom: 16px;
`;
export const FormDescription = styled.div`
	color: ${grey500};
	font-size: 16px;
	line-height: 24px;
`;
export const Notice = styled.p`
	color: ${black};
	font-weight: bold;
	margin-top: 10px;
`;
